module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 3